export default "__VITE_ASSET__BL1s6Utt__"